<template>
  <v-btn @click="logout" v-bind="$attrs" :loading="$store.state.auth.loading">
    <slot></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'LogoutButton',
  methods: {
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'login' })
      })
    }
  }
}
</script>
